import { render } from "./StudentAttendanceDataTable.vue?vue&type=template&id=4173f878&scoped=true"
import script from "./StudentAttendanceDataTable.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceDataTable.vue?vue&type=script&lang=js"

import "./StudentAttendanceDataTable.vue?vue&type=style&index=0&id=4173f878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4173f878"]])

export default __exports__